export default "__VITE_ASSET__opRybWN$__"